import { graphql } from '@/gql/graphql';

export const PERSON_CONTEXT_PAGE_SIZE = 25;

export const GetPersonContextOptions = graphql(/* GraphQL */ `
  query GetPersonContextOptions(
    $personId: String!
    $offset: Int!
    $limit: Int!
  ) {
    teamMemberships: person_team(
      where: { person_id: { _eq: $personId } }
      order_by: [{ team: { title: asc } }, { team_id: asc }]
      limit: $limit
      offset: $offset
    ) {
      person_id
      team_id
      team {
        id
        title
        avatar_id
        home_primary_color
      }
    }
    eventContexts: person_event_context(
      where: {
        person_id: { _eq: $personId }
        event: {
          event_type: { _eq: organization }
          _or: [
            { owner_id: { _eq: $personId } }
            { event_people: { person_id: { _eq: $personId } } }
          ]
        }
      }
      order_by: [{ event: { title: asc } }, { event_id: asc }]
      limit: $limit
      offset: $offset
    ) {
      event {
        id
        title
      }
    }
  }
`);

export const GetPersonSelectedContext = graphql(/* GraphQL */ `
  query GetPersonSelectedContext(
    $personId: String!
    $teamIds: [uuid!]!
    $eventIds: [uuid!]!
  ) {
    teamMemberships: person_team(
      where: { person_id: { _eq: $personId }, team_id: { _in: $teamIds } }
      limit: 1
    ) {
      person_id
      team_id
      role
      member_type
      team {
        id
        title
        permissions
      }
    }
    eventContexts: person_event_context(
      where: {
        person_id: { _eq: $personId }
        event_id: { _in: $eventIds }
        event: {
          event_type: { _eq: organization }
          _or: [
            { owner_id: { _eq: $personId } }
            { event_people: { person_id: { _eq: $personId } } }
          ]
        }
      }
      limit: 1
    ) {
      event {
        id
        title
        owner_id
        permissions
        event_people(where: { person_id: { _eq: $personId } }, limit: 1) {
          person_id
          event_id
          role
        }
      }
    }
  }
`);
